/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */
import React from 'react'

import type { DeploymentTemplateInfoV2 } from '@modules/cloud-api/v1/types'
import type { StackDeployment } from '@modules/ui-types'

import DeploymentGettingStartedCredentials from './DeploymentGettingStartedCredentials'
import DeploymentGettingStartedFailed from './DeploymentGettingStartedFailed'
import DeploymentGettingStartedMedia from './DeploymentGettingStartedMedia'

import type { FC } from 'react'
import type { GettingStartedPhase } from './types'

type DeploymentGettingStartedDetailsProps = {
  deployment: StackDeployment
  deploymentTemplate: DeploymentTemplateInfoV2
  isAnyAdminConsole: boolean
  gettingStartedPhase: GettingStartedPhase
  onCredentialsContinue: () => void
}

export type Props = DeploymentGettingStartedDetailsProps

const DeploymentGettingStartedDetails: FC<DeploymentGettingStartedDetailsProps> = ({
  deployment,
  deploymentTemplate,
  gettingStartedPhase,
  isAnyAdminConsole,
  onCredentialsContinue,
}) => {
  switch (gettingStartedPhase) {
    case 'save-creds':
      return (
        <DeploymentGettingStartedCredentials
          onContinue={onCredentialsContinue}
          deployment={deployment}
          deploymentTemplate={deploymentTemplate}
        />
      )
    case 'creating-deployment':
    case 'deployment-created':
      return <DeploymentGettingStartedMedia isAnyAdminConsole={isAnyAdminConsole} />
    case 'deployment-failed':
      return <DeploymentGettingStartedFailed deployment={deployment} />
    default:
      return null
  }
}

export default DeploymentGettingStartedDetails
